import { useLoyaltyOfferGroupsByIdsQuery } from 'generated/sanity-graphql';
import { blockContentToPlainText } from 'utils/sanity';

import { LoyaltyOffer } from '../types';

export const useLoyaltyOfferGroupsById = (groupId?: string) => {
  const offersGroupId = groupId ?? '';

  const { data, loading, refetch } = useLoyaltyOfferGroupsByIdsQuery({
    variables: {
      groupIds: offersGroupId,
    },
    nextFetchPolicy: 'cache-and-network',
  });

  return {
    loading,
    refetch,
    offerItems: data?.allOfferGroups?.[0]?.offers as LoyaltyOffer[],
    groupName: blockContentToPlainText(data?.allOfferGroups?.[0]?.name?.localeRaw),
  };
};
